<template>
	<payHeader></payHeader>
	<div class="login-main">
		<div class="container">
			<div class="info" >
				<h1><em>蓝队云</em>让云上服务触手可及</h1>
				<h3><em>始于2008年</em>100000+用户见证</h3>
				<p>自有IP地址广播</p>
				<p>公安部等保三级备案云平台</p>
				<p>CNNIC顶级域名注册服务机构</p>
				<p>COP15盛会特聘技术支撑单位</p>
				<p>国家应急中心CNCERT技术支撑单位</p>
			</div>
			<div class="section">
				<span @click="switchChange" :class="accountFlag ? 'switch type2' : 'switch type1'" v-if="!multipleFlag"></span>
				<div v-if="accountFlag" id="login_container">
					<h4 class="title" style="margin-bottom: 10px;">扫码登录</h4>
					<wxlogin style="width: 300px; margin: 0 auto;" scope="snsapi_login" :appid="appid" :state="wxLoginState" :redirect_uri="redirectUri" :href="wxhref"></wxlogin>
					<p class="register">还没有账号？<router-link to="/register">立即注册</router-link></p>
				</div>
				<div v-else>
					<div v-if="loginType == 'phone'">
						<el-form :rules="rulesMobile" ref="ruleMobileRef" :model="mobileForm">
							<div v-if="!multipleFlag">
								<h4 class="title">会员登录</h4>
								<el-form-item prop="mobile" class="mobile">
									<span class="ico">+86(中国大陆)</span>
									<el-input v-model="mobileForm.mobile" placeholder="手机号码" autocomplete="off" />
								</el-form-item>
								<el-form-item prop="code" class="code">
									<span class="ico"></span>
									<el-input v-model="mobileForm.code" placeholder="验证码" autocomplete="off" @keyup.enter="submitMobile(ruleMobileRef)" />
									<el-button type="primary" :disabled="codeSend" @click="codeChange">{{codeSendText}}</el-button>
								</el-form-item>
								<div class="go-reg">
									<span @click="typeChange('account')">账号或邮箱登录</span>
									还没有账号？<router-link to="/register">立即注册</router-link>
								</div>
							</div>
							<div class="check-account" style="height: 212px;" v-else>
								<h4 class="title"><span class="back" @click="backClick">&lt;返回</span>选择登录账号</h4>
								<div class="li" v-for="(item, index) in multipleData" :key="index" @click="multipleChange(index,item.key)" :class="{ 'active': selectedMultiple === index }">{{item.name.username}}
									<div class="tags">
										<el-tag type="info" v-if="item.name.authstatus == 0">未认证</el-tag>
										<el-tag type="success" v-if="item.name.authstatus == 1">个人认证</el-tag>
										<el-tag type="success" v-if="item.name.authstatus == 2">企业认证</el-tag>
										<el-tag type="warning" v-if="item.name.prostatus == 1">保有产品</el-tag>
									</div>
								</div>
							</div>
							<el-form-item>
								<el-button type="primary" class="submit" :disabled="captchaVisible" @click="submitMobile(ruleMobileRef)">登录</el-button>
							</el-form-item>
						</el-form>
					</div>
					<el-form :rules="rulesAccount" ref="ruleAccountRef" :model="accountForm"  v-if="loginType == 'account'">
						<h4 class="title">会员登录</h4>
						<el-form-item prop="username" class="name">
							<span class="ico"></span>
							<el-input v-model="accountForm.username" placeholder="用户名/邮箱" autocomplete="off" />
						</el-form-item>
						<el-form-item prop="password" class="pwd">
							<span class="ico"></span>
							<el-input v-model="accountForm.password" type="password" show-password placeholder="登录密码" autocomplete="off" @keyup.enter="submitAccount(ruleAccountRef)" />
						</el-form-item>
						<div class="go-reg">
							<span @click="typeChange('phone')">手机号码登录</span>
							还没有账号？<router-link to="/register">立即注册</router-link>
						</div>
						<el-form-item>
							<el-button type="primary" class="submit" :disabled="captchaVisible" @click="submitAccount(ruleAccountRef)">登录</el-button>
						</el-form-item>
					</el-form>
					<div class="other" v-if="!multipleFlag">
						<div class="error-text" v-if="errorVisible"><el-icon :size="16" color="#ff4c4f" style="vertical-align: text-top;margin: 2px 2px 0 0;"><Warning /></el-icon><el-text type="danger">{{errorText}}</el-text></div>
						<p>其他账户快捷登录：
							<span class="ico qq" @click="qqChange"></span>
							<span class="ico wx" @click="wxChange"></span>
						</p>
						<router-link to="/repwd">忘记密码？</router-link>
					</div>
				</div>
			</div>
		</div>
		<div class="footer">
		  <div class="container">
		    <p>Copyright © 2005 - {{ currentYear }} LanDui.com. All RightsReserved. 蓝队云 版权所有</p>
		    <p>增值电信业务经营许可证 B1.B2-20181647、滇B1.B2-20190004    滇公安备案 滇53010302000111</p>
		  </div>
		</div>
	</div>
	<el-dialog align-center :close-on-click-modal="false" v-model="captchaVisible" title="请输入图片中的验证码" width="280">
		<el-image :src="captchaImg" @click="captchaReload" fit="contain" alt="验证码" title="点击刷新" style="margin-bottom: 10px;cursor: pointer;" />
	    <div class="captcha-form">
	      <el-form-item label="验证码">
	        <el-input v-model="captchaAnswer" autocomplete="off" @keyup.enter="captchaClick(loginType)" />
	      </el-form-item>
		  <div v-if="errorCapVisible"><el-icon :size="16" color="#ff4c4f" style="vertical-align: text-top;margin: 2px 2px 0 0;"><Warning /></el-icon><el-text type="danger">{{errorCaptcha}}</el-text></div>
	    </div>
	    <template #footer>
	      <div class="dialog-footer">
	        <el-button type="primary" @click="captchaClick(loginType)">{{captchaBtn}}</el-button>
	      </div>
	    </template>
	</el-dialog>
</template>

<script setup>
	import { ref,reactive,inject,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { useStore } from 'vuex';
	import wxlogin from "vue-wxlogin";
	import { ElMessage } from 'element-plus';
	import { captchaFetch,loginSendCode,wechatlogin,qqlogin,loginAccount,loginMobile,getuserhasproduct,accountcheck } from '@/api/home';
	import { payHeader } from 'landui-ui';
	import { Warning } from '@element-plus/icons-vue';
	
	const currentYear = new Date().getFullYear();
	const store = useStore();
	const router = useRouter();
	const domain = inject('domain');
	const errorVisible = ref(false)
	const errorText = ref('')
	const errorCapVisible = ref(false)
	const errorCaptcha = ref('')
	const accountFlag = ref(false)
	const multipleFlag = ref(false)
	const multipleData = ref();
	const selectedMultiple = ref();
	const token = ref('');
	const codeSendText = ref('获取验证码');
	const codeSend = ref(false);
	const codeTime = ref(60);
	const captchaVisible = ref(false);
	const loginCaptcha = ref(false);
	const captchaAnswer = ref('');
	const captchaImg = ref('');
	const captchaId = ref('');
	const captchaBtn = ref('');
	const loginType = ref('phone');
	const reurl = ref('');
	const wxhref = ref('https://static.landui.com/statics/css/front/wxLogin.css');
	const appid = ref('');
	const redirectUri = ref('');
	const wxLoginState = ref('');
	const ruleAccountRef = ref(null);
	const accountForm = ref({username:'',password:''});
	const ruleMobileRef = ref(null);
	const mobileForm = ref({mobile:'',code:''});
	const rulesAccount = reactive({
		username: [
			{ required: true, message: '请填写登录账号', trigger: 'blur' },
		],
		password: [
			{ required: true, message: '请填写登录密码', trigger: 'blur' },
		]
	});
	const rulesMobile = reactive({
		mobile: [
			{ required: true, message: '请填写手机号码', trigger: 'blur' },
			{ min: 11, message: '请填写正确手机号格式', trigger: 'blur' }
		],
		code: [
			{ required: true, message: '请填写验证码', trigger: 'blur' },
		]
	});
	const typeChange = (val) => {
		loginType.value = val;
		errorText.value = ''
		errorVisible.value = false;
		switch(val)
		{
			case 'account':
				ruleMobileRef.value.resetFields()
			break;
			case 'phone':
				ruleAccountRef.value.resetFields()
			break;
		}
	};
	const switchChange = () => {
		accountFlag.value = !accountFlag.value;
		if (accountFlag.value) {
			wechatLoginF()
		}
	}
	const qqChange = () => {
		qqlogin().then((res) => {
			window.location.href = res.data.qqLoginUrl; 
		})
	}
	const wxChange = () => {
		accountFlag.value = true;
		wechatLoginF()
	}
	const wechatLoginF = () => {
		wechatlogin().then((res) => {
			appid.value = res.data.appid;
			redirectUri.value = res.data.redirect_uri;
			wxLoginState.value = res.data.state
		})
	}
	const backClick = () => {
		mobileForm.value = {mobile:'',code:''};
		multipleFlag.value = !multipleFlag.value;
	}
	const codeChange = () => {
		ruleMobileRef.value.validateField('mobile',(valid) => {
			if(valid){
				captchaChange()
				captchaAnswer.value = '';
				captchaId.value = '';
				captchaBtn.value = '发送验证码';
				captchaVisible.value = !captchaVisible.value;
			}
		})
	}
	const captchaChange = () => {
		captchaFetch().then((res) => {
			if (res.code == 200) {
				captchaImg.value = res.data.captcha_data;
				captchaId.value = res.data.captcha_id;
			}
			if (res.code == 205) {
				errorVisible.value = true;
				errorText.value = res.msg
			}
		})
	}
	const captchaClick = (val) => {
		if (val == 'account') {
			captchaVisible.value = !captchaVisible.value;
			submitAccount()
		}
		if (val == 'phone') {
			const param = {
				'captcha_answer':captchaAnswer.value,
				'captcha_id':captchaId.value,
				'mobile':mobileForm.value.mobile,
			}
			loginSendCode(param).then((res) => {
				if (res.code == 200) {
					codeSend.value = true;
					codeSendText.value = codeTime.value+'s后重新发送';
					let timer = setInterval(() => {
					   codeTime.value--;
					   codeSendText.value = codeTime.value + 's后重新发送';
					   if (codeTime.value < 0) {
						   clearInterval(timer);
						   codeSendText.value = '获取验证码';
						   codeTime.value = 60;
						   codeSend.value = false
					   }
					}, 1000)
					captchaVisible.value = !captchaVisible.value;
					errorCapVisible.value = false;
					errorCaptcha.value = '';
				}
				if (res.code == 205) {
					errorCapVisible.value = true;
					errorCaptcha.value = res.msg;
					captchaChange()
					captchaAnswer.value = ''
				}
			})
		}
	}
	const multipleChange = (key,value) => {
		selectedMultiple.value = key;
		token.value = value;
	};
	const accountLogin = (param) => {
		loginAccount(param).then((res) => {
			if(res.code === 200){
				if (res.data.checkWechat) {
					if (reurl.value !== '' && reurl.value !== undefined) {
						window.location.href = reurl.value;
					} else{
						window.location.href = domain+"/user";
					}
				} else{
					router.push({ path: '/registerWx' })
				}
			}
			if (res.code == 205) {
				errorVisible.value = true;
				errorText.value = res.msg;
			}
		})
	}
	const submitAccount = () => {
		if (!ruleAccountRef.value) return;
		ruleAccountRef.value.validate((valid) => {
			if (valid) {
				const param = accountForm.value;
				if (loginCaptcha.value) {
					param['captcha_answer'] = captchaAnswer.value;
					param['captcha_id'] = captchaId.value;
				}
				if (captchaAnswer.value !== '') {
					accountLogin(param)
					captchaAnswer.value = '';
				}else{
					accountcheck({'username':accountForm.value.username}).then((res) => {
						if(res.code === 200){
						  if (res.data.is_captcha) {
							captchaChange()
							captchaAnswer.value = '';
							captchaBtn.value = '确定';
							captchaVisible.value = true;
							loginCaptcha.value = true;
						  }else{
							accountLogin(param)
						  }
						}
					})
				}
			} else {
			  return false;
			}
		});
	};
	const submitMobile = () => {
		if (!ruleMobileRef.value) return;
		ruleMobileRef.value.validate((valid) => {
			if (valid) {
				const param = mobileForm.value;
				if (multipleFlag.value) {
					param['way'] = 'token';
					param['code'] = token.value;
				} else{
					param['way'] = 'mobile'
				}
				loginMobile(param).then((res) => {
					if(res.code === 200){
						if (res.data.ischoose == '1') {
							const chooseData = res.data.unamelist;
							getuserhasproduct({'mobile':mobileForm.value.mobile}).then((data) => {
								if (data.code == 200) {
									const result = {};
									Object.keys(data.data).forEach(key => {
									  // 检查 obj2 是否包含相同的键
									  if (Object.prototype.hasOwnProperty.call(chooseData, key)) {
									    // 创建一个新的对象来存储合并后的数据
									    const newObj = {
									      ...chooseData[key], // 复制 obj2[key] 的所有属性
									      prostatus: data.data[key] // 添加 pro 属性
									    };
									    // 将新对象添加到结果对象中
									    result[key] = newObj;
									  }
									});
									const unamelist = result;
									const transformedData = [];
									for (const [key, name] of Object.entries(unamelist)) {
									    transformedData.push({
									        key: key,
									        name: name
									    });
									}
									multipleData.value = transformedData;
									multipleFlag.value = true;
								}
							})
						} else{
							if (res.data.checkWechat) {
								if (reurl.value !== '' && reurl.value !== undefined) {
									window.location.href = reurl.value;
								} else{
									window.location.href = domain+"/user";
								}
							} else{
								router.push({ path: '/registerWx' })
							}
						}
					}
					if (res.code == 205) {
						errorVisible.value = true;
						errorText.value = res.msg
					}
				})
			} else {
			  return false;
			}
		});
	};
	const captchaReload = () => {
		captchaChange()
	}
	
	
	onMounted(() => {
		if(router.currentRoute.value.query){
			reurl.value = router.currentRoute.value.query.reurl
		}
		wechatLoginF()
	});
	
</script>

<style lang="scss">
	.title{text-align: center; font-size: 20px; margin-bottom: 30px;}
	.error-info{height: 20px; overflow: hidden;}
	.error-text{ text-align: left; background-color: #fff; position: absolute; right: 30px; left: 28px; bottom: 202px;}
	.check-account{
		margin: 0 !important;
		overflow: hidden;
		.back{float: left;font-size: 14px;color: #015BFE; line-height: 30px; cursor: pointer;}
		.li{
			border: 1px solid #dfdfdf;
			margin-bottom: 10px;
			padding: 12px 10px;
			font-size: 12px;
			color: #666;
			position: relative;
			padding-right: 170px;
			padding-left: 35px;
			background: url(../../assets/images/radio-normal.png) 10px center no-repeat;
			cursor: pointer;
			overflow: hidden;
			p{color: #333; font-size: 14px; margin-bottom: 2px;}
			.tags{position: absolute;right: 0;top: 8px;}
			.el-tag{margin-right: 10px;}
		}
		.active{
			border-color: #015BFE;
			background: url(../../assets/images/radio-checked.png) 10px center #E6EFFF no-repeat;
			p{font-weight: 600;}
		}
	}
	#login_container{
		padding: 40px 30px 0;
		.register {
		    display: block;
		    color: #666;
		    border-top: 1px solid #ddd;
		    line-height: 66px;
		}
		iframe{height: 293px !important;}
	}
	.login-main{
		background: url(../../assets/images/login-bg.jpg) center no-repeat;
		background-size: cover;
		height: 100vh;
		padding-top: 245px;
		min-width: 1280px;
		.container{width: 1280px;margin: 0 auto;}
		.info{
			float: left;
			color: #fff;
			padding: 33px 0 0 80px;
			overflow: hidden;
			h1 {
			    margin-bottom: 25px;
			    font-size: 24px;
				em {
				    float: left;
				    margin-right: 18px;
				}
				em::after {
				    content: "";
					float: right;
					width: 6px;
					height: 6px;
					background: #fff;
					border-radius: 100%;
					margin: 12px 0 0 16px;
				}
			}
			h3 {
			    font-size: 20px;
			    margin-bottom: 50px;
				em {
				    float: left;
				    margin-right: 16px;
				}
				em::after {
				    content: "";
				    float: right;
				    width: 2px;
				    height: 18px;
				    background: #fff;
				    margin: 5px 0 0 20px;
				}
			}
			p {
			    height: 24px;
			    line-height: 24px;
			    font-size: 16px;
			    margin-bottom: 15px;
			}
			p::before{
				    content: "";
					float: left;
					width: 6px;
					height: 6px;
					background: #fff;
					border-radius: 100%;
					margin: 10px 12px 0 0;
				}
		}
		.section{
			float: right;
			width: 440px;
			background: #fff;
			height: 440px;
			margin-right: 90px;
			position: relative;
			overflow: hidden;
			.switch{width: 40px;height: 40px;position: absolute;right: 15px;top: 15px; z-index: 1; cursor: pointer;}
			.type1{background: url(../../assets/images/switch-ewm.png) right top no-repeat;}
			.type2{background: url(../../assets/images/switch-pwd.png) right top no-repeat;}
			.submit{
				width: 100%;
				height: 48px;
				line-height: 48px;
				font-size: 18px;
				margin-top: 30px;
				background: #015bfe;
			}
			.submit.is-disabled{
				background:#ccc;
				border-color:#ccc;
			}
			.other{
				text-align: right;
				line-height: 20px;
				margin: 0 30px;
				overflow: hidden;
				p{
					float: left;
					.ico{width: 20px;height: 20px; display: inline-block; vertical-align: middle; margin-right: 9px;cursor: pointer;}
					.qq{background: url(../../assets/images/qq.png) center no-repeat;}
					.wx{background: url(../../assets/images/wx.png) center no-repeat;}
				}
			}
			.el-form{
				position: relative;
				padding: 40px 30px 0;
				.el-form-item{
					.el-input{
						width: 100% !important;
						height: 50px;
						--el-input-height:50px;
					}
					.el-input__suffix{margin-right: 8px;}
					.el-input__wrapper{padding: 1px;}
					.el-input__inner{padding-left: 40px;}
					.ico{
						position: absolute;
						left: 0;
						top: 0;
						bottom: 0;
						z-index: 1;
						font-size: 13px;
						padding-left: 43px;
						line-height: 50px;
						cursor: pointer;
					}
				}
				.mobile{
					.el-input__inner{padding-left: 140px;}
					.ico{background: url(../../assets/images/tel.png) 16px center no-repeat; }
				}
				.name{
					.ico{background: url(../../assets/images/name.png) 16px center no-repeat; }
				}
				.pwd{
					.ico{background: url(../../assets/images/pwd.png) 16px center no-repeat; }
				}
				.code{
					overflow: visible;
					.el-button{position: absolute;top: 9px; right: 8px; width: 110px; text-align: center;}
					.ico{background: url(../../assets/images/code.png) 16px center no-repeat; }
				}
				.go-reg{
					margin-top: 40px;
					text-align: right;
					color: #666;
					overflow: hidden;
					span{ float: left; cursor: pointer;color: #015bfe;}
				}
			}
		}
		.footer {
		    color: #999;
		    line-height: 28px;
		    text-align: center;
			padding-top: 100px;
		    min-width: 1280px;
		    overflow: hidden;
		}
	}
	
</style>